<ng-template>
    <div (click)="closed.emit()" class="btn-nieuwestroom btn-dropdown">
        <ng-content></ng-content>
    </div>
</ng-template>